import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Iconify from '../../../components/iconify';

// ----------------------------------------------------------------------

export default function DueDateFiltersResult({
    filters,
    onFilters,
    onResetFilters,
    results,
    ...other
}) {
    const handleRemoveFilter = (filterName) => {
        onFilters(filterName, false); // Remove the filter
    };

    // Define filter items
    const filterItems = [
        { label: 'Today', value: 'today' },
        { label: 'Tomorrow', value: 'tomorrow' },
        { label: 'This Week', value: 'week' },
        { label: 'Over Due', value: 'overdue' },
        { label: 'Over Run', value: 'overrun' },
    ];

    // Determine active filters
    const activeFilters = filterItems.filter(
        (filter) => filters.some((columnFilter) => columnFilter.id === filter.value)
    );

    return (
        <Stack spacing={1.5} {...other}>
            <Box sx={{ typography: 'body2' }}>
                <strong>{results}</strong>
                <Box component="span" sx={{ color: 'text.secondary', ml: 0.25 }}>
                    results found
                </Box>
            </Box>

            <Stack flexGrow={1} spacing={1} direction="row" flexWrap="wrap" alignItems="center">
                {activeFilters.map((filter) => (
                    <Block key={filter.value} label="Due Date:">
                        <Chip
                            size="small"
                            label={filter.label}
                            onDelete={() => handleRemoveFilter(filter.value)}
                        />
                    </Block>
                ))}

                <Button color="error" onClick={onResetFilters} startIcon={<Iconify icon="solar:trash-bin-trash-bold" />}>
                    Clear
                </Button>
            </Stack>
        </Stack>
    );
}

DueDateFiltersResult.propTypes = {
    filters: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string.isRequired,
    })),
    onFilters: PropTypes.func,
    onResetFilters: PropTypes.func,
    results: PropTypes.number,
};

// ----------------------------------------------------------------------

function Block({ label, children, sx, ...other }) {
    return (
        <Stack
            component={Paper}
            variant="outlined"
            spacing={1}
            direction="row"
            sx={{
                p: 1,
                borderRadius: 1,
                overflow: 'hidden',
                borderStyle: 'dashed',
                ...sx,
            }}
            {...other}
        >
            <Box component="span" sx={{ typography: 'subtitle2' }}>
                {label}
            </Box>

            <Stack spacing={1} direction="row" flexWrap="wrap">
                {children}
            </Stack>
        </Stack>
    );
}

Block.propTypes = {
    children: PropTypes.node,
    label: PropTypes.string,
    sx: PropTypes.object,
};
